import React from 'react';
import { useSnackbar, SnackbarPublicProps } from 'pounceV2';
import { copyTextToClipboard } from 'Helpers/utils';

const successfulCopyProps: SnackbarPublicProps = {
  variant: 'default',
  title: 'Copied to clipboard',
  duration: 1500,
};

const errorCopyProps: SnackbarPublicProps = {
  variant: 'error',
  title: 'Error copying to clipboard',
  duration: 1500,
};

const useCopyToClipboardV3 = () => {
  const { pushSnackbar } = useSnackbar();

  return React.useCallback(
    async (value: any, successfulCopy = successfulCopyProps, errorCopy = errorCopyProps) => {
      try {
        await copyTextToClipboard(value);
        pushSnackbar(successfulCopy);
      } catch (err) {
        pushSnackbar(errorCopy);
      }
    },
    [pushSnackbar],
  );
};

export default useCopyToClipboardV3;
